module.exports = __webpack_public_path__ + "background.fd33082.png";